import {inject, Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Router} from '@angular/router';
import {UserStateService} from '@services/frontend/user-state.service';
import {NotificationService} from '@services/frontend/notification.service';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable()
export class UserInterceptor implements HttpInterceptor {

  private readonly router = inject(Router);
  private readonly userStateService = inject(UserStateService);
  private readonly notificationService = inject(NotificationService);

  private isRedirecting = false;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        if ((error.status === 401 || error.status === 403) && !this.isLoginRequest(req)) {
          if (!this.isRedirecting) {
            this.isRedirecting = true;
            this.userStateService.deleteToken();
            this.notificationService.warning('Votre session a expiré, veuillez vous reconnecter.', 5000);
            void this.router.navigate(['/login']).then(() => {
              this.isRedirecting = false;
            });
          }
        }

        return throwError(() => error);
      })
    );
  }

  private isLoginRequest(req: HttpRequest<any>): boolean {
    return req.url.includes('/auth/login')
      || req.url.includes('/auth/register')
      || req.url.includes('/auth/forgot-password')
      || req.url.includes('/auth/forgot-identifier');
  }
}
